import { ParamsOptions, ParseParamsFn, ResolveParams } from '@tanstack/react-router';
import { ENVIRONMENTS_NAMES, EnvironmentsNames } from 'utils';
import * as z from 'zod/v4';

type Params<S extends z.ZodType | undefined = undefined> = {
  otherParamsSchema?: S;
};

type Resolver<
  Path extends `${string}/$env${string}`,
  S extends z.ZodType | undefined = undefined,
> = S extends z.ZodType
  ? z.infer<S> & ResolveParams<Path> & { env: EnvironmentsNames }
  : ResolveParams<Path> & { env: EnvironmentsNames };

export function parseEnv<
  Path extends `${string}/$env${string}`,
  S extends z.ZodType | undefined = undefined,
>({ otherParamsSchema = undefined }: Params<S> = {}): ParamsOptions<
  Path,
  Resolver<Path, S>
>['params'] {
  return {
    parse: (param => {
      const p = param as { env: string };
      return {
        ...(otherParamsSchema
          ? (otherParamsSchema.parse(param) as Record<string, unknown>)
          : param),
        env: z.enum(ENVIRONMENTS_NAMES).parse(p.env),
      };
    }) as ParseParamsFn<Path, Resolver<Path, S>>,
  };
}
